import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckmark = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 17,
	viewBox: "0 0 16 17",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M8 0.5C12.4183 0.5 16 4.08172 16 8.5C16 12.9183 12.4183 16.5 8 16.5C3.58172 16.5 0 12.9183 0 8.5C0 4.08172 3.58172 0.5 8 0.5ZM11.3584 6.14645C11.1849 5.97288 10.9154 5.9536 10.7206 6.08859L10.6513 6.14645L7 9.798L5.35355 8.15131L5.28431 8.09346C5.08944 7.95846 4.82001 7.97775 4.64645 8.15131C4.47288 8.32488 4.4536 8.59431 4.58859 8.78917L4.64645 8.85842L6.64645 10.8584L6.71569 10.9163C6.8862 11.0344 7.1138 11.0344 7.28431 10.9163L7.35355 10.8584L11.3584 6.85355L11.4163 6.78431C11.5513 6.58944 11.532 6.32001 11.3584 6.14645Z",
		fill: "#999"
	})]
});
const ForwardRef = forwardRef(SvgCheckmark);
export default ForwardRef;
